<template>
  <authStepsLayout :step="step">
    <register ref="register" @step="step = $event" />
  </authStepsLayout>
</template>
<script>
import register from "../../views/login/register.vue";
import authStepsLayout from "./authStepsLayout.vue";

export default {
  components: { register, authStepsLayout },
  data() {
    return { step: 1 };
  },
};
</script>
